import { Theme, makeStyles } from '@material-ui/core';
import { borderRadius, colors, inputBorderRadius } from '../theme';

interface IProps {
  height?: number;
}

const useStyles = makeStyles<Theme, IProps>((theme) => ({
  errorIcon: {
    color: 'red',
  },
  smTextInputClass: props => ({
    '& .MuiInputBase-root': {
      height: props.height || '32px',
      minWidth: '64px',
    },
  }),
  mdTextInputClass: props => ({
    '& .MuiInputBase-root': {
      height: props.height || '40px',
      minWidth: '72px',
    },
  }),
  lgTextInputClass: props => ({
    '& .MuiInputBase-root': {
      height: props.height || '48px',
      minWidth: '80px',
    },
  }),
  inputWrapper: {
    display: 'flex',
    width: '100%',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.primary.mainBlue,
      '&:focused': {
        borderColor: colors.primary.mainBlue,
      },
      '&:hover': {
        borderColor: colors.primary.darkBlue,
      },
    },
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .MuiInputBase-root': {
      borderRadius: inputBorderRadius,
    },
  },
}));

export default useStyles;
